import { Component, Input, OnChanges, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomerspagesService } from '../../customerspages.service';
import { CommonModule, ViewportScroller } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-case-study-hero',
  templateUrl: './case-study-hero.component.html',
  styleUrls: ['./case-study-hero.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class CaseStudyHeroComponent implements OnInit, OnChanges, OnDestroy {
  @Input() artData: any;
  constructor(
    private viewportScroller: ViewportScroller,
    private customersPagesService: CustomerspagesService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  heroData: any;

  ngOnInit(): void {}
  ngOnChanges(): void {
    const data = this.artData;
    if (data != null) {
      let hero = data?.customerStoryHeroPanel?.fields;
      this.heroData = {
        header: hero?.title || '',
        paragraph: hero?.content || '',
        badge:
          hero?.tags && hero?.tags.length
            ? hero?.tags[0]?.fields?.tagText
            : '',
        image: {
          url: hero?.image?.[0]?.fields?.file?.url || '',
          alt: hero?.image?.[0]?.fields?.title || '',
        },
      };
      if (hero?.buttons) {
        this.heroData.buttons = hero?.buttons.map((e:any) => e.fields);
      }
      if (data?.psCustomerStoryPdf) {
        this.heroData.psCustomerStoryPdf = data?.psCustomerStoryPdf;
      }
    }
  }
  public scrollTo(): void {
    this.viewportScroller.scrollToAnchor('downloadForm');
  }
}
